import React from 'react';

import { useAuth } from '../../../../app/AuthorizationProvider';

interface YAxisLabelsProps {
  ticks: number[];
  afterLabels?: string[];
  isPercentage?: boolean;
}

export const YAxisLabels: React.FC<YAxisLabelsProps> = ({ ticks, afterLabels, isPercentage = false }) => {
  const { locale } = useAuth();

  return (
    <div className="scheduling-chart__y-axis-wrapper">
      <div className="scheduling-chart__y-axis-container">
        {ticks.map((tick) => (
          <span data-test-id={`tick-${tick}`} key={tick}>
            {tick.toLocaleString(locale, isPercentage ? { maximumFractionDigits: 2, style: 'percent' } : undefined)}
          </span>
        ))}
      </div>
      {afterLabels?.map((label) => (
        <span data-test-id={`after-label-${label}`} className="scheduling-chart__y-axis__description" key={label}>
          {label}
        </span>
      ))}
    </div>
  );
};
